import React, { useEffect, useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { PageHero } from '../components/PageHero';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface Angel {
  name: string;
  years: string;
  bio: string;
  photo: string;
}
const angels: Angel[] = [{
  name: 'Василишин Володимир',
  years: '15/03/1988 - 22/07/2023',
  bio: 'Став на захист країни на початку повномасштабного вторгнення. Парамедик 241 окремої бригади Сил територіальної оборони, мав звання сержанта. Постійно вчився, удосконалювався, шукав можливість бути корисним ближче до фронту. Разом із побратимами вивіз і врятував не один десяток бійців. Його позивний Веселий — завжди з посмішкою, з доброю енергією, з умінням підтримати інших.\n\nБув альпіністом, скайранером, рятувальником, гідом, кандидатом у майстри спорту та чемпіоном України зі спортивного туризму. Зробив сходження на Казбек, Монблан, Маттерхорн, а мрією було — піднятися на восьмитисячник Манаслу.',
  photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&q=80'
}, {
  name: 'Ковальчук Дмитро',
  years: '08/11/1985 - 14/05/2022',
  bio: 'Досвідчений альпініст, інструктор з скелелазіння. З перших днів повномасштабного вторгнення пішов добровольцем до лав Збройних Сил України. Служив у складі гірсько-штурмової бригади. Використовував свій досвід альпініста для підготовки бійців до дій у гірській місцевості.\n\nМайстер спорту з альпінізму, здійснив понад 50 сходжень різної категорії складності. Був наставником для молодих спортсменів, організовував безкоштовні тренування для дітей.',
  photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&q=80'
}, {
  name: 'Петренко Андрій',
  years: '24/06/1990 - 03/09/2023',
  bio: 'Кандидат у майстри спорту з альпінізму, член збірної команди України. Захищав Україну у складі десантно-штурмових військ. Відзначений за мужність та відвагу під час бойових дій на сході України.\n\nЗдійснив сходження на найвищі вершини Кавказу та Альп. Був активним учасником рятувальних операцій у горах, волонтером гірської служби порятунку. Мріяв після перемоги організувати всеукраїнський фестиваль альпінізму.',
  photo: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&q=80'
}, {
  name: 'Сидоренко Олексій',
  years: '12/02/1995 - 19/01/2024',
  bio: 'Скелелаз, призер чемпіонатів України з боулдерингу. Пішов на фронт добровольцем у 2022 році. Служив розвідником, використовуючи навички скелелазіння у бойових умовах.\n\nБув одним із найперспективніших молодих скелелазів України. Тренувався під керівництвом провідних тренерів країни, мав амбіційні плани щодо участі у міжнародних змаганнях. Завжди допомагав молодшим спортсменам, був прикладом відданості спорту та країні.',
  photo: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&q=80'
}, {
  name: 'Мельник Ігор',
  years: '30/04/1978 - 27/08/2022',
  bio: "Майстер спорту з альпінізму, інструктор першої категорії. З початку повномасштабного вторгнення — боєць Збройних Сил України. Загинув, виконуючи бойове завдання.\n\nЗа свою спортивну кар'єру здійснив сходження на вершини понад 7000 метрів, був учасником кількох гімалайських експедицій. Працював гірським гідом, водив групи у Карпатах та на Кавказі. Виховав ціле покоління молодих альпіністів.",
  photo: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&q=80'
}];
function slugify(name: string) {
  return name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-zA-Zа-яА-ЯіІїЇєЄґҐ0-9-]/g, '');
}
function AngelCard({
  angel,
  index
}: {
  angel: Angel;
  index: number;
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  return <motion.div id={slugify(angel.name)} key={index} initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-40px'
  }} transition={{
    duration: 0.6,
    delay: 0.1
  }} className="flex flex-col sm:flex-row items-center sm:items-start gap-6 pb-10 border-b border-gray-200 last:border-b-0 last:pb-0 scroll-mt-28" data-id="element-426">
      {/* Photo */}
      <div className="w-[120px] h-[120px] rounded-full overflow-hidden flex-shrink-0 border-4 border-gray-200 shadow-sm" data-id="element-427">
        <img src={angel.photo} alt={angel.name} className="w-full h-full object-cover grayscale" data-id="element-428" />
      </div>

      {/* Bio */}
      <div className="text-center sm:text-left flex-1 min-w-0" data-id="element-429">
        <h2 className="text-xl font-heading font-bold text-primary" data-id="element-430">
          {angel.name}
        </h2>
        <p className="text-xs text-gray-400 font-medium tracking-wide mt-0.5" data-id="element-431">
          {angel.years}
        </p>

        <div className="relative mt-3" data-id="element-432">
          <motion.div animate={{
          height: isExpanded ? 'auto' : 120
        }} transition={{
          duration: 0.3,
          ease: 'easeInOut'
        }} className="overflow-hidden relative" data-id="element-433">
            <div className="space-y-3" data-id="element-434">
              {angel.bio.split('\n\n').map((paragraph, pi) => <p key={pi} className="text-gray-600 text-sm leading-relaxed" data-id="element-435">
                  {paragraph}
                </p>)}
            </div>
          </motion.div>

          {/* Fade overlay when collapsed */}
          <AnimatePresence data-id="element-436">
            {!isExpanded && <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 0.2
          }} className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-gray-50 via-gray-50/80 to-transparent pointer-events-none" data-id="element-437" />}
          </AnimatePresence>
        </div>

        {/* Expand/Collapse toggle */}
        <button onClick={() => setIsExpanded(!isExpanded)} className="mt-2 inline-flex items-center gap-1 text-xs font-medium text-primary/60 hover:text-primary transition-colors" data-id="element-438">
          {isExpanded ? 'Згорнути' : 'Читати далі'}
          <ChevronDown className={`h-3.5 w-3.5 transition-transform duration-200 ${isExpanded ? 'rotate-180' : ''}`} data-id="element-439" />
        </button>
      </div>
    </motion.div>;
}
export function AngelsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleScrollTo = (name: string) => {
    const el = document.getElementById(slugify(name));
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-440">
      <Header data-id="element-441" />
      <main className="pt-20" data-id="element-442">
        <PageHero label="Пам'ять" title="Янголи" subtitle="Загиблі скелелази та альпіністи під час війни. Вічна пам'ять героям, які віддали своє життя за Україну." data-id="element-443" />

        {/* Quick Navigation - full width, above cards */}
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 mt-8" data-id="element-444">
          <div className="relative w-full" data-id="element-445">
            <select id="angel-nav" defaultValue="" onChange={e => {
            if (e.target.value) {
              handleScrollTo(e.target.value);
              e.target.value = '';
            }
          }} className="w-full appearance-none bg-white border border-gray-200 text-gray-700 py-3 px-4 pr-10 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-colors shadow-sm cursor-pointer" data-id="element-446">
              <option value="" disabled data-id="element-447">
                Перейти до - оберіть ім'я...
              </option>
              {angels.map(angel => <option key={angel.name} value={angel.name} data-id="element-448">
                  {angel.name}
                </option>)}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-400" data-id="element-449">
              <ChevronDown className="h-4 w-4" data-id="element-450" />
            </div>
          </div>
        </div>

        {/* Memorial List */}
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-451">
          <div className="space-y-10" data-id="element-452">
            {angels.map((angel, index) => <AngelCard key={index} angel={angel} index={index} data-id="element-453" />)}
          </div>

          {/* Memorial Note */}
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="mt-16 text-center py-10 border-t border-gray-200" data-id="element-454">
            <p className="text-lg font-heading font-semibold text-primary/80" data-id="element-455">
              Вічна пам'ять та слава
            </p>
            <p className="mt-2 text-sm text-gray-500" data-id="element-456">
              Якщо ви маєте інформацію про загиблих членів федерації, будь
              ласка, зв'яжіться з нами за адресою{' '}
              <a href="mailto:info@umcf.org.ua" className="text-primary hover:underline" data-id="element-457">
                info@umcf.org.ua
              </a>
            </p>
          </motion.div>
        </div>
      </main>
      <Footer data-id="element-458" />
    </div>;
}